import axios from "axios";

const raw = process.env.REACT_APP_BACKEND_URL;
const BASE = raw ? `${String(raw).replace(/\/$/, "")}/api` : "/api";

const client = axios.create({ baseURL: BASE, timeout: 20000 });

export const fetchConfig = () => client.get("/config").then((r) => r.data);
export const fetchLeaderboard = () => client.get("/leaderboard").then((r) => r.data);
export const fetchStats = () => client.get("/stats").then((r) => r.data);
export const fetchTrending = () => client.get("/trending").then((r) => r.data);
export const fetchActivity = () => client.get("/activity").then((r) => r.data);
export const fetchListing = (id) => client.get(`/listings/${id}`).then((r) => r.data);
export const trackClick = (id) => client.post(`/listings/${id}/click`).then((r) => r.data);
export const createNewListingCheckout = (payload) =>
    client.post("/listings/checkout", payload).then((r) => r.data);
export const createTopupCheckout = (id, payload) =>
    client.post(`/listings/${id}/topup/checkout`, payload).then((r) => r.data);
export const fetchPaymentStatus = (id) =>
    client.get(`/payments/${id}/status`).then((r) => r.data);
export const fetchHype = () => client.get("/hype").then((r) => r.data);
export const fetchHypeActivity = () => client.get("/hype/activity").then((r) => r.data);
export const fetchTweetPreview = (url) =>
    client.get("/hype/tweet-preview", { params: { url } }).then((r) => r.data);
export const createHypeListing = (payload) =>
    client.post("/hype", payload).then((r) => r.data);
export const trackHypeClick = (id) => client.post(`/hype/${id}/click`).then((r) => r.data);
export const joinWaitlist = (email) =>
    client.post("/waitlist", { email }).then((r) => r.data);

/** Wallet auth headers for the sponsor marketplace (demo wallets need no token). */
const walletHeaders = (wallet) => {
    if (!wallet?.id) return undefined;
    return wallet.token
        ? { "x-wallet-id": wallet.id, "x-wallet-token": wallet.token }
        : { "x-wallet-id": wallet.id };
};

export const fetchMarket = (params = {}, wallet) =>
    client.get("/market", { params, headers: walletHeaders(wallet) }).then((r) => r.data);
export const fetchMarketStats = () => client.get("/market/stats").then((r) => r.data);
export const fetchMarketActivity = (limit = 20) =>
    client.get("/market/activity", { params: { limit } }).then((r) => r.data);
export const fetchMarketSponsors = () => client.get("/market/sponsors").then((r) => r.data);
export const fetchMarketListing = (id, wallet) =>
    client.get(`/market/listings/${id}`, { headers: walletHeaders(wallet) }).then((r) => r.data);
export const fetchCreatorProfile = (handle) =>
    client.get(`/market/creators/${handle}`).then((r) => r.data);
export const createMarketListing = (payload) =>
    client.post("/market/listings", payload).then((r) => r.data);
export const closeMarketListing = (id) =>
    client.post(`/market/listings/${id}/close`, {}).then((r) => r.data);
export const placeMarketBid = (id, payload, wallet) =>
    client
        .post(`/market/listings/${id}/bids`, payload, { headers: walletHeaders(wallet) })
        .then((r) => r.data);
export const createMarketWallet = (label) =>
    client.post("/market/wallets", { label }).then((r) => r.data);
export const createDemoSponsorWallet = (sponsorId) =>
    client.post("/market/wallets/demo", { sponsor_id: sponsorId }).then((r) => r.data);
export const fetchMarketWallet = (id, wallet) =>
    client.get(`/market/wallets/${id}`, { headers: walletHeaders(wallet) }).then((r) => r.data);
export const topUpMarketWallet = (id, amountUsd, wallet) =>
    client
        .post(`/market/wallets/${id}/topup`, { amount_usd: amountUsd }, { headers: walletHeaders(wallet) })
        .then((r) => r.data);
export const fetchDeal = (dealId, wallet) =>
    client.get(`/market/proofs/${dealId}`, { headers: walletHeaders(wallet) }).then((r) => r.data);
export const submitMarketFeedback = (note, context) =>
    client.post("/market/feedback", { note, context }).then((r) => r.data);
export const submitDealProof = (dealId, payload, wallet) =>
    client
        .post(`/market/proofs/${dealId}`, payload, { headers: walletHeaders(wallet) })
        .then((r) => r.data);
export const reviewDealProof = (dealId, payload, wallet) =>
    client
        .post(`/market/proofs/${dealId}/review`, payload, { headers: walletHeaders(wallet) })
        .then((r) => r.data);

export default client;
